import { render } from "./Nases.vue?vue&type=template&id=1d39316e"
import script from "./Nases.vue?vue&type=script&lang=js"
export * from "./Nases.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__